F<template>
  <section class="race-events" :class="{'has-error': errorMessage}">
      <span class="loading">
        Loading
      </span>
    <transition name="toast">
      <span class="error-message" v-if="errorMessage">
        {{ errorMessage }}
      </span>
    </transition>
  </section>
</template>

<style lang="scss">
.race-events {
  color: var(--text-color);
  max-width: 500px;
  height: 100vh;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  
  .error-message {
    display: block;
    position: absolute;
    top: 44px;
    left: 0;
    right: 0;
    height: 44px;
    line-height: 44px;
    border-radius: 22px;
    text-align: center;
    text-shadow: 0 0 10px #000;
    font-weight: bold;
    background: rgb(255 0 0 / 0.9);
    box-shadow: 0 0 10px rgb(0 0 0 / 0.7);
  }
  
  .loading {
    transition: 0.74s ease all;
    filter: grayscale(0%) brightness(1);
    
    background: url('~@/assets/img/aravaipa-logo-round.png') 50% 50% no-repeat;
    margin: 0 auto;
    height: 150px;
    width: 150px;
    border-radius: 50%;
    box-shadow: 0 0 40px #22878F;
    text-indent: -9999px;
    animation: fadein 2s ease-in 0s infinite normal,
               pulse 3s linear 2s infinite alternate;
  }
  
  &.has-error {
    .loading {
      animation: none;
      filter: grayscale(50%) brightness(0.25);
    }
  }
}

.toast-enter-from { opacity: 0; transform: translateY(-16px); }
.toast-enter-to   { opacity: 1; transform: translateY(0px); }
.toast-enter-active { transition: 0.74s ease-in all; }

@keyframes fadein {
  0%    { opacity: 0; }
  100%  { opacity: 1; }
};


@keyframes pulse {
  0% {   box-shadow: 0 0 40px #22878F; opacity: 1;}
  50% {  box-shadow: 0 0 5px red; opacity: 0.8;}
  100% { box-shadow: 0 0 40px #22878F; opacity: 1; }
};
</style>

<script>
export default {
    name: 'RaceEvents',    
    data() {
      return {
        loading: false,
        loadedAt: undefined, 
        errorMessage: null,
        raceEventLoadOffset: 0,
      }
    },
    
    computed: {
      raceEvents() {
        if (!this.$store.state.raceEvents)
          return [];
      
        return Object.values(this.$store.state.raceEvents).sort((a,b)=>{
          a = a.startTime || a.createdAt || -Infinity;  // createdAt may not be loaded by indexes
          b = b.startTime || b.createdAt || -Infinity;  // createdAt may not be loaded by indexes
          return b - a;
        });
      },
      
      raceEventsDisplay() {
        if (!this.raceEvents) return {}
      
        let nextUp, current=[], upcoming;
        let events = [...this.raceEvents];
        console.debug("events:", events);
      
        let futureIndex; // index of the first event that is in the future
        let now = Date.now();
        // now = new Date('5/29/2021 6:01 am');
        // now = new Date('4/10/2022 9:11 am');
        // now = new Date(now - (48 * 3600 * 1000));
        console.log("NOW: ", now);
        for (var i = 0; i < events.length; i++) {
          const future = !events[i].startTime || events[i].startTime.getTime() > now;
          if (future) {
            futureIndex = i;
          }
          else {
            break;
          }
        }

        console.debug(`Index of first future event: ${futureIndex} (${events[futureIndex] && events[futureIndex].name})`)

        if (futureIndex >= 0) {
          upcoming = events.splice(0, futureIndex+1);
          nextUp = upcoming.pop();
        }
        
        // Get current event
        // Add current events until past cutoff time is found
        for (var i = 0; i < events.length; i++) {
          let e = events[i];
          console.debug(`cutoff ${e.cutoffTime} < ${now} ${e.cutoffTime < now ? 'yes' : 'no'}`);
          if (e.cutoffTime > now) {
            current.push(e);
            events.splice(i, 1); // remove from events
          }
        }

        return {
          nextUp,
          upcoming: upcoming && upcoming.reverse(),
          current,
          past: events
        }
      }
    },
    
    mounted() {
      console.debug("race-events: mounted and loading");
      this.loading = true;
      this.loadedAt = new Date();
            
      Promise.all([
        this.$store.dispatch('loadRaceEvents'), 
        new Promise((resolve) => setTimeout(resolve, 1000))
      ])
      .then(() => {
        this.loading = false;
        this.autoSelectRaceEvent()
      })
      .catch((e) => {
        this.errorMessage = "Unable to load events";
        console.error("Error: ", e);
      })
    },

    methods: {
      autoSelectRaceEvent() {
        let params = new URLSearchParams(window.location.search);
        let reid = params.get('reid');
        if (reid) {
          // Find it. If it doesn't exist, it wasn't in the initial load and 
          // we need to specifically get it.
          if (!this.$store.state.raceEvents[reid]) {
            console.error(`Could not find event ${reid}`)
            this.errorMessage = "Event not found";
            return;
          }
          
          this.clickedRaceEvent(this.$store.state.raceEvents[reid]);
          return;
        }
        
        // Otherwise we need to select the most likely event.
        if (this.raceEventsDisplay.current.length)
          return this.clickedRaceEvent(this.raceEventsDisplay.current[0]);
        
        // Get the next event
        if (this.raceEventsDisplay.nextUp)
          return this.clickedRaceEvent(this.raceEventsDisplay.nextUp);
        
        // There are no races.
        this.errorMessage = "No events available for check in";
      },
      
      async clickedRaceEvent(re) {
        console.log("Clicked re", re);
        
        // preload the image

        await new Promise((resolve, reject) => {
          let im = new Image();
          im.addEventListener('load', () => {
            console.debug("image loaded");
            resolve();
          });
          im.addEventListener('error', (err) => {
            console.error("Could not load image", err);
            reject(err);
          });
          im.src = re.avatarUrl;
          console.debug(`preloading: complete? ${im.complete}`, im);
          if (im.complete) resolve();
        });
        
        this.$router.push({name: 'raceEvent', params: { raceEventSlug: re.slug }});
      },
      
      clickedRace(re, r) {
        console.debug("Clicked race", re, r);
        this.$router.push({name: 'raceEvent', params: { raceEventSlug: re.slug, raceId: r.id}, query: {raceId: r.id}})
      },
      
      loadMoreRaceEvents(e) {
        console.debug(`Loading race events with offset ${this.raceEventLoadOffset + 10}`);
        e && e.preventDefault();

        // Attempt to load the next 10, incrementing our offset tracker upon success.
        this.loading = true;
        this.$store.dispatch('loadRaceEvents', { offset: this.raceEventLoadOffset + 10}).then(() => {
          this.loading = false;
          this.raceEventLoadOffset += 10;
        });
      }
    }
  }
</script>